// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fire-risk-legend {
  /* Required by react-draggable */
  position: relative;
 
  /* Your existing styles */
  background: var(--map-surface);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid var(--map-border);
  border-radius: 16px;
  box-shadow:
    0 0 24px rgba(225, 6, 19, 0.12),
    0 8px 32px rgba(0, 0, 0, 0.4);
  padding: 14px 16px;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 12px;
 
  /* Prevent text selection while dragging */
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  transition: box-shadow 0.2s ease;
}
 
.fire-risk-legend.dragging {
  box-shadow:
    0 0 32px rgba(225, 6, 19, 0.2),
    0 12px 48px rgba(0, 0, 0, 0.5);
  z-index: 100;
}
 
/* Drag handle — header only */
.frl-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: grab;
  padding-top: 14px;
  padding-bottom: 4px;
  margin: -4px -4px 8px -4px;
  border-radius: 8px;
  transition: background 0.15s ease;
}
 
.frl-header:hover {
  background: rgba(255, 255, 255, 0.04);
}
 
.fire-risk-legend.dragging .frl-header {
  cursor: grabbing;
}
 
/* Subtle grip indicator */
.frl-header::before {
  content: '';
  display: block;
  width: 24px;
  height: 3px;
  background: var(--map-text-muted);
  border-radius: 2px;
  opacity: 0.3;
  position: absolute;
  top: 4px;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}
 
/* Re-enable selection on inputs */
.fire-risk-legend input,
.fire-risk-legend input * {
  user-select: auto;
  -webkit-user-select: auto;
}
 
.frl-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--map-text-primary);
}
 
.frl-info-btn {
  background: transparent;
  border: 1px solid var(--map-border);
  border-radius: 50%;
  color: var(--map-text-muted);
  width: 22px;
  height: 22px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: border-color 0.2s, color 0.2s;
}
 
.frl-info-btn:hover {
  border-color: var(--map-danger);
  color: var(--map-text-primary);
}
 
.frl-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
 
/* add to existing CSS */
 
.frl-item {
  display: flex;
  align-items: center;
  gap: 12px;
}
 
.frl-text {
  flex: 1 1;
}
 
.frl-eye-btn {
  background: transparent;
  border: 1px solid var(--map-border);
  border-radius: 6px;
  color: var(--map-text-muted);
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: border-color 0.2s, color 0.2s;
}
 
.frl-eye-btn:hover {
  border-color: var(--map-danger);
  color: var(--map-text-primary);
}
 
.frl-bar {
  display: block;
  width: 6px;
  height: 36px;
  border-radius: 4px;
  flex-shrink: 0;
}
 
.frl-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
 
.frl-level {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: var(--map-text-primary);
}
 
.frl-prob {
  font-size: 11px;
  color: var(--map-text-muted);
}
.frl-close-btn {
  background: transparent;
  border: 1px solid var(--map-border);
  border-radius: 50%;
  color: var(--map-text-muted);
  width: 22px;
  height: 22px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: border-color 0.2s, color 0.2s;
}
.frl-close-btn:hover {
  border-color: var(--map-danger);
  color: var(--map-text-primary);
}
.frl-opacity-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--map-border);
}
 
.frl-opacity-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: var(--map-text-primary);
  flex-shrink: 0;
}
 
.frl-opacity-value {
  font-size: 13px;
  font-weight: 700;
  color: var(--map-text-primary);
  flex-shrink: 0;
  min-width: 30px;
  text-align: right;
}
 
.frl-opacity-slider {
  flex: 1 1;
  height: 6px;
  accent-color: var(--map-danger);
  cursor: pointer;
  appearance: none;
  background: var(--map-text-muted);
  border-radius: 2px;
  outline: none;
}
 
.frl-opacity-slider::-webkit-slider-thumb {
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: var(--map-danger);
  cursor: pointer;
}
 
@media (max-width: 768px) {

  /* ── GLOBAL POPUP SIZE ── */
  .fire-risk-legend {
    min-width: 120px;          /* ⬇️ beaucoup plus petit */
    padding: 5px 6px;          /* ⬇️ réduit fortement */
    gap: 4px;
    border-radius: 12px;
    transform: scale(0.82);    /* ⬇️ shrink global */
    transform-origin: bottom left;
  }

  /* ── HEADER ── */
  .frl-header {
    padding-top: 6px;
    margin-bottom: 4px;
  }

  .frl-title {
    font-size: 8.5px;
    letter-spacing: 0.6px;
  }

  .frl-close-btn {
    width: 16px;
    height: 16px;
    font-size: 9px;
  }

  /* ── ITEMS LIST ── */
  .frl-items {
    gap: 4px;
  }

  .frl-item {
    gap: 2px; /* 👈 TEXT + EYE ULTRA PROCHES */
  }

  /* ── COLOR BAR ── */
  .frl-bar {
    width: 3px;
    height: 18px;
  }

  /* ── TEXT ── */
  .frl-level {
    font-size: 9px;
    letter-spacing: 0.4px;
  }

  /* ── EYE BUTTON ── */
  .frl-eye-btn {
    width: 16px;
    height: 16px;
  }

  /* ── OPACITY SECTION ── */
  .frl-opacity-row {
    padding-top: 4px;
    gap: 4px;
  }

  .frl-opacity-label {
    font-size: 8px;
  }

  .frl-opacity-value {
    font-size: 8px;
    min-width: 22px;
  }

  .frl-opacity-slider {
    height: 3px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/fireRiskLegend/FireRiskLegend.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,kBAAkB;;EAElB,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB;;iCAE+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,0CAA0C;EAC1C,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;;kCAEgC;EAChC,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;;EAEE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B;IACE,gBAAgB,WAAW,2BAA2B;IACtD,gBAAgB,WAAW,wBAAwB;IACnD,QAAQ;IACR,mBAAmB;IACnB,sBAAsB,KAAK,qBAAqB;IAChD,6BAA6B;EAC/B;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA,qBAAqB;EACrB;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ,EAAE,gCAAgC;EAC5C;;EAEA,oBAAoB;EACpB;IACE,UAAU;IACV,YAAY;EACd;;EAEA,eAAe;EACf;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,YAAY;EACd;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".fire-risk-legend {\n  /* Required by react-draggable */\n  position: relative;\n \n  /* Your existing styles */\n  background: var(--map-surface);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid var(--map-border);\n  border-radius: 16px;\n  box-shadow:\n    0 0 24px rgba(225, 6, 19, 0.12),\n    0 8px 32px rgba(0, 0, 0, 0.4);\n  padding: 14px 16px;\n  min-width: 200px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n \n  /* Prevent text selection while dragging */\n  user-select: none;\n  touch-action: none;\n  transition: box-shadow 0.2s ease;\n}\n \n.fire-risk-legend.dragging {\n  box-shadow:\n    0 0 32px rgba(225, 6, 19, 0.2),\n    0 12px 48px rgba(0, 0, 0, 0.5);\n  z-index: 100;\n}\n \n/* Drag handle — header only */\n.frl-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: grab;\n  padding-top: 14px;\n  padding-bottom: 4px;\n  margin: -4px -4px 8px -4px;\n  border-radius: 8px;\n  transition: background 0.15s ease;\n}\n \n.frl-header:hover {\n  background: rgba(255, 255, 255, 0.04);\n}\n \n.fire-risk-legend.dragging .frl-header {\n  cursor: grabbing;\n}\n \n/* Subtle grip indicator */\n.frl-header::before {\n  content: '';\n  display: block;\n  width: 24px;\n  height: 3px;\n  background: var(--map-text-muted);\n  border-radius: 2px;\n  opacity: 0.3;\n  position: absolute;\n  top: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  pointer-events: none;\n}\n \n/* Re-enable selection on inputs */\n.fire-risk-legend input,\n.fire-risk-legend input * {\n  user-select: auto;\n  -webkit-user-select: auto;\n}\n \n.frl-title {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--map-text-primary);\n}\n \n.frl-info-btn {\n  background: transparent;\n  border: 1px solid var(--map-border);\n  border-radius: 50%;\n  color: var(--map-text-muted);\n  width: 22px;\n  height: 22px;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: border-color 0.2s, color 0.2s;\n}\n \n.frl-info-btn:hover {\n  border-color: var(--map-danger);\n  color: var(--map-text-primary);\n}\n \n.frl-items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n \n/* add to existing CSS */\n \n.frl-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n \n.frl-text {\n  flex: 1;\n}\n \n.frl-eye-btn {\n  background: transparent;\n  border: 1px solid var(--map-border);\n  border-radius: 6px;\n  color: var(--map-text-muted);\n  width: 26px;\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition: border-color 0.2s, color 0.2s;\n}\n \n.frl-eye-btn:hover {\n  border-color: var(--map-danger);\n  color: var(--map-text-primary);\n}\n \n.frl-bar {\n  display: block;\n  width: 6px;\n  height: 36px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n \n.frl-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n \n.frl-level {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  color: var(--map-text-primary);\n}\n \n.frl-prob {\n  font-size: 11px;\n  color: var(--map-text-muted);\n}\n.frl-close-btn {\n  background: transparent;\n  border: 1px solid var(--map-border);\n  border-radius: 50%;\n  color: var(--map-text-muted);\n  width: 22px;\n  height: 22px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: border-color 0.2s, color 0.2s;\n}\n.frl-close-btn:hover {\n  border-color: var(--map-danger);\n  color: var(--map-text-primary);\n}\n.frl-opacity-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--map-border);\n}\n \n.frl-opacity-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  color: var(--map-text-primary);\n  flex-shrink: 0;\n}\n \n.frl-opacity-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--map-text-primary);\n  flex-shrink: 0;\n  min-width: 30px;\n  text-align: right;\n}\n \n.frl-opacity-slider {\n  flex: 1;\n  height: 6px;\n  accent-color: var(--map-danger);\n  cursor: pointer;\n  appearance: none;\n  background: var(--map-text-muted);\n  border-radius: 2px;\n  outline: none;\n}\n \n.frl-opacity-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: var(--map-danger);\n  cursor: pointer;\n}\n \n@media (max-width: 768px) {\n\n  /* ── GLOBAL POPUP SIZE ── */\n  .fire-risk-legend {\n    min-width: 120px;          /* ⬇️ beaucoup plus petit */\n    padding: 5px 6px;          /* ⬇️ réduit fortement */\n    gap: 4px;\n    border-radius: 12px;\n    transform: scale(0.82);    /* ⬇️ shrink global */\n    transform-origin: bottom left;\n  }\n\n  /* ── HEADER ── */\n  .frl-header {\n    padding-top: 6px;\n    margin-bottom: 4px;\n  }\n\n  .frl-title {\n    font-size: 8.5px;\n    letter-spacing: 0.6px;\n  }\n\n  .frl-close-btn {\n    width: 16px;\n    height: 16px;\n    font-size: 9px;\n  }\n\n  /* ── ITEMS LIST ── */\n  .frl-items {\n    gap: 4px;\n  }\n\n  .frl-item {\n    gap: 2px; /* 👈 TEXT + EYE ULTRA PROCHES */\n  }\n\n  /* ── COLOR BAR ── */\n  .frl-bar {\n    width: 3px;\n    height: 18px;\n  }\n\n  /* ── TEXT ── */\n  .frl-level {\n    font-size: 9px;\n    letter-spacing: 0.4px;\n  }\n\n  /* ── EYE BUTTON ── */\n  .frl-eye-btn {\n    width: 16px;\n    height: 16px;\n  }\n\n  /* ── OPACITY SECTION ── */\n  .frl-opacity-row {\n    padding-top: 4px;\n    gap: 4px;\n  }\n\n  .frl-opacity-label {\n    font-size: 8px;\n  }\n\n  .frl-opacity-value {\n    font-size: 8px;\n    min-width: 22px;\n  }\n\n  .frl-opacity-slider {\n    height: 3px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
